import { http } from "@/http/http.js";


export function getRelatedUser(params) {
    return http.post("/web/accountManage/getRelatedUser",params)
}

export function getAccountManageMore(params) {
    return http.post("/web/accountManage/more",params)
}

export function accountManageAdd(params) {
    return http.post("/web/accountManage/add",params)
}

export function statisticInfo(params) {
    return http.post("/web/accountManage/statisticInfo",params)
}

export function autoCreate(params) {
    return http.post("/web/accountManage/autoCreate",params)
}

export function accountManagedelete(params) {
    return http.post("/web/accountManage/delete",params)
}
export function updatePwd(params) {
    return http.post("/web/accountManage/updatePwd",params)
}
export function resetPwd(params) {
    return http.post("/web/accountManage/resetPwd",params)
}
export function accountManageActive(params) {
    return http.post("/web/accountManage/active",params)
}
export function accountManageUpdate(params) {
    return http.post("/web/accountManage/update",params)
}
export function listAccountMenu(params) {
    return http.post("/web/accountManage/listAccountMenu",params)
}

export function saveAccountMenu(params) {
    return http.post("/web/accountManage/saveAccountMenu",params)
}